import React, {useContext, useEffect, useState} from "react";
import {Box, Paper, Stack, Typography} from "@mui/material";
import {useLxTranslations} from "@lxo-blocks/react";

import {AuthenticationHandler, useAuthenticate} from "../../useAuthenticate";
import CancelMfaSignInButton from "../../../../common/CancelMfaSignInButton";

import MfaPushMobileImage from "../../../../common/images/MfaPushMobileImage";
import MfaPushLoginError from "./MfaPushLoginError";
import {MFAPUSH_VIEW_TRANSLATION} from "./MfaPushView.translation.de";
import {AuthenticationContext, MfaContext} from "../../AuthenticateView";

import RetryButton from "./components/RetryButton";
import {MfaPushRemeberDeviceFormCheckbox} from "./components/MfaPushRemeberDeviceFormCheckbox";
import useDeviceConfirmation from "./hooks/useDeviceConfirmation";
import ChangeMethodButton from "../changeMethod/components/ChangeMethodButton";


interface StepMfaPushProps {
  authenticationHandler: AuthenticationHandler,
}

export default function MfaPushView(props: StepMfaPushProps) {
  const {t, LxTrans} = useLxTranslations(MFAPUSH_VIEW_TRANSLATION);
  const [rememberDeviceChecked, setRememberDeviceChecked] = useState(false);
  const authenticationContext = useContext(AuthenticationContext);
  const mfaContext = useContext(MfaContext);
  const {authenticate, authenticateByTicket, authenticationError} = useAuthenticate(props.authenticationHandler);

  const {
    confirmedPollingTicket,
    pollingError,
    cancelPolling,
    retrySeconds,
    retryAllowed
  } = useDeviceConfirmation(mfaContext?.mfaRequiredData.ticketId, mfaContext?.userId);

  useEffect(() => {
    if (confirmedPollingTicket) {
      authenticateByTicket(confirmedPollingTicket, rememberDeviceChecked);
    } // eslint-disable-next-line
  }, [confirmedPollingTicket]);


  const retryAuthentication = async () => {
    cancelPolling();
    authenticate({...authenticationContext, mfaMethod: "MOBILEPUSH"});
  }

  return (
    <>
      <Paper sx={{px: 2, pt: 2, pb: 7}}>
        {!pollingError && !authenticationError && (
          <>
            <Box>
              <Typography className="Title" variant="body2" sx={{pb: 2}}>
                <LxTrans
                  i18nKey={"MFAPUSH_HEADLINE"} components={{bold: <strong/>}}
                  values={{device: mfaContext?.mfaRequiredData.deviceNames ? mfaContext?.mfaRequiredData.deviceNames[0] : null}}/>
              </Typography>
              <Typography className="Title" variant="body2" sx={{pb: 2}}>
                <LxTrans
                  i18nKey={"MFAPUSH_DESCRIPTION_1"}
                  values={{device: mfaContext?.mfaRequiredData.deviceNames ? mfaContext?.mfaRequiredData.deviceNames[0] : null}}/>
              </Typography>
            </Box>
            <Box>
              <Typography className="Title" variant="body2" sx={{pb: 2}}>
                {t("MFAPUSH_DESCRIPTION_2")}
              </Typography>
            </Box>

            <Box sx={{p: 3}}
                 display="flex"
                 justifyContent="center"
                 alignItems="center">
              <MfaPushMobileImage/>
            </Box>

            <Box sx={{pt: 2, pb: 5, pr: 8, pl: 8}}
                 display="flex"
                 justifyContent="center"
                 alignItems="center">
              <MfaPushRemeberDeviceFormCheckbox checked={rememberDeviceChecked}
                                                onChange={e => setRememberDeviceChecked(e.target.checked)}/>
            </Box>
          </>
        )}
        {(pollingError || authenticationError) && (
          <MfaPushLoginError/>
        )}

        <Box style={{float: "right"}}>
          <RetryButton sendNewPush={retryAuthentication} disabled={!retryAllowed} countdown={retrySeconds}/>
        </Box>

      </Paper>

      <Stack spacing={2} direction="row-reverse" style={{float: "right"}} mt={2}>
        <ChangeMethodButton onChangeMethod={props.authenticationHandler.onChangeMethod}/>
        <CancelMfaSignInButton/>
      </Stack>
    </>
  );
}
